export function getHostnameFromURL(url) {
	let hostname = ''

	if (typeof url !== 'string' || !url.length) {
		return hostname
	}

	try {
		hostname = new URL(url).hostname
	} catch {}

	return hostname
}

export function getQueryParamsFromUrl(url) {
	let queryParams = {}

	try {
		const urlObject = new URL(url)
		const searchParamsEntries = urlObject.searchParams.entries()

		queryParams = Object.fromEntries(searchParamsEntries)
	} catch {}

	return queryParams
}
